import { render, staticRenderFns } from "./SoFunktioniertPage.vue?vue&type=template&id=7f5269b4&scoped=true&"
import script from "./SoFunktioniertPage.vue?vue&type=script&lang=js&"
export * from "./SoFunktioniertPage.vue?vue&type=script&lang=js&"
import style0 from "./SoFunktioniertPage.vue?vue&type=style&index=0&id=7f5269b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5269b4",
  null
  
)

export default component.exports